module.exports = new __parcel__URL__("../images/gabs.b7e789bd.png").toString();